<template>
  <el-row>
    <el-row>
      <el-button v-has="'/holiday/add'"
                 :disabled="pagination.total > 18"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <el-button v-has="'/holiday/batch_del'"
                 type="primary"
                 @click="multipleDelete">批量删除</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column fixed="left"
                         type="selection"
                         width="80">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'start_time' || item.prop === 'end_time'">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row[item.prop] }}</span>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="260">
          <template slot-scope="scope">
            <el-button v-has="'/holiday/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/holiday/batch_del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-holiday v-if="showHolidayModal"
                 :isShow="showHolidayModal"
                 :data="holidayData"
                 @handleClose="closeHolidayModal"></add-holiday>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddHoliday from '@/views/basic/holiday/AddHoliday'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddHoliday, Pagination },
  data() {
    return {
      tableTitle: [
        {
          prop: 'name',
          name: '名称',
          width: '100',
          fixed: 'left'
        },
        {
          prop: 'dt_begin',
          name: '起止时间',
          width: '100'
        },
        {
          prop: 'dt_end',
          name: '结束时间',
          width: '100'
        },
        {
          prop: 'remarks',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加假日相关
      showHolidayModal: false,
      holidayData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getHolidayList({
          currentPage: currentPage,
          perPage: perPage
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.tableData = data.list
              this.pagination.total = Number(data.total)
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加假日管理
    handleAdd() {
      this.showHolidayModal = true
      this.holidayData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delHoliday(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择假日设置后重试')
      }
    },
    // 编辑
    handleEdit(data) {
      this.showHolidayModal = true
      this.holidayData = {
        type: 'edit',
        id: data.id
      }
    },
    closeHolidayModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHolidayModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delHoliday(data.id)
        })
        .catch(() => {})
    },
    // 删除假日
    delHoliday(ids) {
      fetch.batchDelHoliday({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style></style>
